import { Controller } from "@hotwired/stimulus"
import { Turbo } from "@hotwired/turbo-rails"

// Sidebar "Modo privacidad" switch (PrivacyModeHelper::COOKIE). Flips <html data-privacy-mode>
// so the CSS blurs right away, then reloads so server-rendered titles follow.
export default class extends Controller {
  toggle(event) {
    const enabled = event.target.checked
    const maxAge = enabled ? 60 * 60 * 24 * 365 : 0
    document.cookie = `privacy_mode=${enabled ? 1 : ""}; path=/; max-age=${maxAge}; samesite=lax`
    document.documentElement.toggleAttribute("data-privacy-mode", enabled)

    // Snapshots taken before the switch would come back unblurred on "back".
    Turbo.cache.clear()
    Turbo.visit(window.location.href, { action: "replace" })
  }
}
